// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:1366px){.header-wrapper.scrolled{box-shadow:2px 0 14px 3px rgba(0,0,0,.1)}}@media (max-width:1365px){.header-wrapper.scrolled header{box-shadow:2px 0 14px 3px rgba(0,0,0,.1)}}", ""]);
// Exports
module.exports = exports;
